import { tv } from 'tailwind-variants'

export const cardVariants = tv({
  slots: {
    card: '',
    shadow: '',
    discount: 'absolute -top-4 -right-9 size-[75px]',
    title: '',
    subtitle: '',
  },
  variants: {
    theme: {
      'green-seagreen': {
        shadow: ' [--shadow:var(--color-green-pop)]',
        card: 'border border-green-50',
        discount: '[--stroke:var(--color-green-50)]',
        title: 'text-green-30',
      },
      'dark-red-pink': {
        shadow: '[--shadow:var(--color-coral-pop)]',
        card: 'border border-red-40',
        discount: '[--stroke:var(--color-red-40)]',
        title: 'text-black-80',
      },
      'blue-pink': {
        shadow: '[--shadow:var(--color-orange-30)]',
        card: 'border border-blue-30',
        discount: '[--stroke:var(--color-blue-30)]',
        title: 'text-black-80',
      },
      'green-red': {
        shadow: '[--shadow:var(--color-yellow-legacy-40)]',
        card: 'border border-green-50',
        discount: '[--stroke:var(--color-green-50)]',
        title: 'text-green-30',
      },
    },
  },
  compoundVariants: [
    {
      theme: ['green-seagreen', 'green-red'],
      class: {
        title: 'font-headline',
        subtitle: 'text-sm leading-6! text-green-30 md:text-base',
      },
    },
    {
      theme: ['dark-red-pink', 'blue-pink'],
      class: {
        subtitle: 'text-lg leading-10! font-semibold text-black-80 md:text-xl',
      },
    },
  ],
})

export type CardVariantsClasses = ReturnType<typeof cardVariants>
